module.exports = __webpack_public_path__ + "img/img28.48ba0606.svg";